import React from 'react';

import { versionNumber } from 'config/settings';

const Version = () => (<p>Version: {versionNumber}. This is a hobby project - no guarantees of uptime are provided!</p>);

export default Version;
